import { Link } from "@tanstack/react-router";
import { Arrow } from "@/components/icons";
import { site } from "@/content";
import { TiltCard } from "@/components/motion";

type Item = { label: string; href?: string; summary?: string };

export function PlaceholderPage(props: {
  eyebrow: string;
  heading: string;
  description: string;
  items?: Item[];
}) {
  return (
    <div className="bg-background text-foreground">
      <section className="mx-auto max-w-4xl px-6 py-16 md:py-20">
        <h1 className="hero-enter mt-4 font-serif text-4xl leading-[1.1] text-ink sm:text-5xl">
          {props.heading}
        </h1>
        <p className="hero-enter-delay mt-6 max-w-2xl text-lg leading-relaxed text-ink/80">
          {props.description}
        </p>

        {props.items && props.items.length > 0 && (
          <ul className="stagger mt-12 grid gap-4 sm:grid-cols-2">
            {props.items.map((it) => {
              const body = (
                <>
                  <span className="block font-serif text-lg text-ink">{it.label}</span>
                  {it.summary && (
                    <span className="mt-2 block text-sm leading-relaxed text-subtle">
                      {it.summary}
                    </span>
                  )}
                </>
              );
              return (
                <li key={it.label}>
                  <TiltCard className="card-premium h-full p-6">
                    {it.href ? (
                      <Link to={it.href} className="block">
                        {body}
                      </Link>
                    ) : (
                      body
                    )}
                  </TiltCard>
                </li>
              );
            })}
          </ul>
        )}

        <div className="reveal card-premium mt-16 p-8">
          <h2 className="font-serif text-2xl text-ink">Not sure which one you need?</h2>
          <p className="mt-2 max-w-2xl leading-relaxed text-ink/80">
            Fair enough, most people aren't. A Strategic Finance Review with Jamee sorts that out in
            one sitting.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to={site.primaryCta.href} className="btn-primary">
              {site.primaryCta.label}
              <Arrow className="h-4 w-4" />
            </Link>
            <Link to={site.secondaryCta.href} className="btn-secondary">
              {site.secondaryCta.label}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
